import React from 'react';
import { Radio, Row } from 'antd';
import { FormField, maxLength, number, alphaNumeric } from 'common';
import { useSelector } from 'react-redux';
import { AppState } from 'store';
import { FieldArray, getFormValues } from 'redux-form';
import globalStyles from 'common/global.module.scss';
import {
  OtherTabSearchBy,
  OtherTabFieldNames,
  NYC_DB_FORM_NAME,
} from '../../consts';
import { AddressesFormFields } from 'pages/Search/templates';

const warnAlphaNumeric = [maxLength(30), alphaNumeric];
const warnReel = [maxLength(4), number];
const warnPage = [maxLength(4), number];
const {
  DOCUMENTS,
  LIENS,
  UNIFORM_COMMERCIAL,
  ENVIRONMENTAL_CONTROL,
  EMERGENCY_REPAIRS,
} = OtherTabSearchBy;

const {
  SEARCHBY,
  REEL,
  FILE_NUMBER,
  CRFN,
  PAGE,
  CONTROL_NUMBER,
  DOCUMENT_ID,
  ADDRESSES,
} = OtherTabFieldNames;

const OtherTab: React.FC = () => {
  const {
    formValues: {
      otherTab: { searchBy },
    },
  }: any = useSelector((state: AppState) => ({
    formValues: getFormValues(NYC_DB_FORM_NAME)(state),
  }));

  return (
    <>
      <FormField
        className={`m-0`}
        name={SEARCHBY}
        inputType="radioGroup"
        tooltip="Select search criteria"
      >
        <Radio value={DOCUMENTS}>Recorded Document</Radio>
        <Radio value={LIENS}>Judgment/Lien</Radio>
        <Radio value={UNIFORM_COMMERCIAL}>UCC</Radio>
        <Radio value={ENVIRONMENTAL_CONTROL}>ECB by Address</Radio>
        <Radio value={EMERGENCY_REPAIRS}>NYC Emergency Repair</Radio>
      </FormField>

      <Row type="flex">
        <FormField
          tabIndex="100"
          disabled={searchBy !== DOCUMENTS && searchBy !== UNIFORM_COMMERCIAL}
          label="Document ID"
          name={DOCUMENT_ID}
          autoFocus={true}
          tooltip="Document"
          className={globalStyles.input}
        />
        <FormField
          tabIndex="200"
          disabled={searchBy !== DOCUMENTS && searchBy !== UNIFORM_COMMERCIAL}
          warn={warnAlphaNumeric}
          label="CRFN"
          name={CRFN}
          tooltip="City Register File Number"
          className={globalStyles.input}
        />
      </Row>
      <Row type="flex">
        <FormField
          tabIndex="300"
          disabled={searchBy !== DOCUMENTS}
          warn={warnReel}
          inputType="inputNumber"
          label="Reel"
          name={REEL}
          tooltip="Reel"
          className={globalStyles.input}
        />
        <FormField
          tabIndex="400"
          disabled={searchBy !== DOCUMENTS}
          warn={warnPage}
          inputType="inputNumber"
          label="Page"
          name={PAGE}
          tooltip="Page"
          className={globalStyles.input}
        />
      </Row>
      <Row type="flex">
        <FormField
          tabIndex="500"
          disabled={searchBy !== UNIFORM_COMMERCIAL}
          warn={warnAlphaNumeric}
          label="File Number"
          name={FILE_NUMBER}
          tooltip="File Number"
          className={globalStyles.input}
        />
        <FormField
          tabIndex="600"
          disabled={searchBy !== LIENS}
          warn={warnAlphaNumeric}
          label="Control Number"
          name={CONTROL_NUMBER}
          tooltip="Control Number"
          className={globalStyles.input}
        />
      </Row>
      <FieldArray
        name={ADDRESSES}
        component={AddressesFormFields}
        fieldsDisabled={
          searchBy !== ENVIRONMENTAL_CONTROL && searchBy !== EMERGENCY_REPAIRS
        }
        inputStyle={globalStyles.input}
        tabNamePrefix="otherTab"
        startingTabIndex={700}
      />
    </>
  );
};

export default React.memo(OtherTab);
